export const AboutComponent = () => {
    return <div><h1 style={{"textAlign":'center'}}>COMING SOON</h1></div>
}